<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-card flat>
          <div class="text-center mt-4">
            <v-chip
              v-for="(item, i) in regions"
              :key="i"
              class="ma-2"
              color="primary"
              >{{ item.ll_region }}</v-chip
            >
          </div>
          <v-card-actions>
            <v-container fluid>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-menu
                    v-model="menuStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedStart"
                        label="Début"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="start"
                      no-title
                      @input="menuStart = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-menu
                    v-model="menuEnd"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedEnd"
                        label="Fin"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="end"
                      no-title
                      @input="menuEnd = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="projetSelected"
                    :items="projets"
                    outlined
                    dense
                    label="Projets"
                    item-text="ll_programme"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="activiteSelected"
                    :items="activitesFiltered"
                    outlined
                    dense
                    label="Activites"
                    item-text="ll_parcours"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    style="width: 390px;"
                    @change="buildrequest()"
                    v-model="animateurSelected"
                    :items="animateursDeProjets"
                    outlined
                    dense
                    label="Animateurs"
                    item-text="displayName"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-right my-0 py-0">
                  <v-btn
                    class="mr-4"
                    color="primary"
                    @click="getdotationsDeGroupesderegions(regionSupervisees)"
                    :loading="loading"
                  >
                    Afficher dotations
                  </v-btn>
                  <v-btn
                    v-if="isSuperviseur"
                    color="info"
                    @click="
                      getMembresDesDotationsDeGroupesderegions(
                        regionSupervisees
                      )
                    "
                  >
                    Afficher Membres
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
          <v-card-text>
            <!--  {{ query.sn.K }} -->
            <template>
              <div class="text-center">
                <v-dialog v-model="dialogEditDotation" width="500">
                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Edition de la dotation
                    </v-card-title>

                    <v-card-text>
                      <v-form>
                        <v-text-field
                          v-model="dotationSelected.ll_dotation"
                          label="Dotation"
                        ></v-text-field>

                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="computedDateDotation"
                              label="Date de la dotation"
                              prepend-icon="mdi-calendar-cursor"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            locale="fr"
                            v-model="dotationSelected.date_dotation"
                            no-title
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-btn
                        rounded
                        color="warning"
                        @click="closeDialogEditDotation()"
                        >Annuler</v-btn
                      >
                      <v-btn rounded color="success" @click="doEditDotation()"
                        >Sauvegarder</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </template>
            <vue-excel-xlsx
              class="mr-4"
              v-if="dotationsDeGroupeRegion.length > 0"
              :data="dotationsDeGroupeRegion"
              :columns="headers"
              :filename="'dotations_' + Date.now()"
              :sheetname="'dotations'"
            >
              <v-btn class="blue" dark>
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Télécharger les
                {{ dotationsDeGroupeRegion.length }} dotations</v-btn
              >
            </vue-excel-xlsx>
            <vue-excel-xlsx
              v-if="MembresDotationsDeGroupeRegion.length > 0"
              :data="MembresDotationsDeGroupeRegion"
              :columns="headersMembres"
              :filename="'membres_dotations_' + Date.now()"
              :sheetname="'membres'"
            >
              <v-btn class="info" dark>
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Télécharger les
                {{ MembresDotationsDeGroupeRegion.length }} membres</v-btn
              >
            </vue-excel-xlsx>

            <v-tabs v-model="tab" class="elevation-0">
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#dotations">
                Groupes
              </v-tab>

              <v-tab href="#membres" v-if="isSuperviseur">
                Membres
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item value="dotations">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Rechercher"
                  single-line
                  hide-details
                  class="mb-4"
                ></v-text-field>
                <v-data-table
                  :headers="headers"
                  :items="dotationsDeGroupeRegion"
                  :items-per-page="20"
                  class="elevation-1"
                  :search="search"
                  locale="fr"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-container style="width: 200px;">
                      <v-row no-gutters>
                        <v-col
                          class="mx-1"
                          style="flex-grow: 0;"
                          v-if="user.role == 'regionalFull'"
                        >
                          <v-btn
                            @click="editDotation(item)"
                            class="mr-2"
                            fab
                            dark
                            x-small
                            color="warning"
                          >
                            <v-icon dark>
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col
                          class="mx-1"
                          style="flex-grow: 0;"
                          v-if="user.role == 'regionalFull'"
                        >
                          <v-btn
                            @click="deleteDotationAndPresence(item)"
                            class="mr-2"
                            fab
                            dark
                            x-small
                            color="danger"
                          >
                            <v-icon dark>
                              mdi-trash-can
                            </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col
                          class="mx-1"
                          style="flex-grow: 0;"
                          v-if="user.role == 'regionalFull' || isOperateur"
                        >
                          <v-btn
                            @click="gotoPresenceDotationDeGroupe(item)"
                            class="mx-0"
                            fab
                            dark
                            x-small
                            color="green"
                          >
                            <v-icon>
                              mdi-chevron-right
                            </v-icon>
                          </v-btn></v-col
                        >
                      </v-row>
                    </v-container>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item value="membres">
                <v-data-table
                  :headers="headersMembres"
                  :items="MembresDotationsDeGroupeRegion"
                  :items-per-page="20"
                  class="elevation-1"
                  :search="search"
                  locale="fr"
                >
                  <template v-slot:item.sexe="{ item }">
                    {{ getSexe(item.sexe) }}
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  watch: {
    projetSelected: function (val) {
      let activitesFiltered = _.filter(this.activites, {
        programmes_id_programme: val,
      });
      this.activitesFiltered = activitesFiltered;
    },
  },
  created() {
    this.SetProjectList();
    this.getDetailsRegionsSupervisees(this.listeRegionsSupervisees);
    this.getAnimateurs(this.regionSupervisees);
    this.getProjets();
    this.getActivites();
  },
  data() {
    return {
      ProjetctList: [],
      tab: "dotations",
      search: "",
      dialogEditDotation: false,
      dotationSelected: { ll_dotation: "", date_dotation: "" },
      menu2: false,
      regions: [],
      query: { sn: { K: {} } },
      request: { projets: null, animateurs: null, activites: null },
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      loading: false,
      menuStart: false,
      menuEnd: false,
      start: this.$moment(Date.now()).subtract(1, "year").format("YYYY-MM-DD"),
      end: this.$moment(Date.now()).format("YYYY-MM-DD"),
      headers: [
        {
          text: "Actions",
          value: "actions",
        },
        {
          text: "Dotation",
          value: "ll_dotation",
          label: "Dotation",
          field: "ll_dotation",
        },
        {
          text: "Totaux",
          value: "nombreTotal",
          label: "Totaux",
          field: "nombreTotal",
        },
        {
          text: "Détails",
          value: "nbDetail",
          label: "Détails",
          field: "nbDetail",
        },

        {
          text: "Date",
          value: "date_dotation",
          label: "Date",
          field: "date_dotation",
        },
        {
          text: "Groupe",
          value: "nom_groupe",
          label: "Groupe",
          field: "nom_groupe",
        },
        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          text: "Projet",
          value: "ll_programme",
          label: "Projet",
          field: "ll_programme",
        },
        {
          text: "Activité",
          value: "ll_parcours",
          label: "Activité",
          field: "ll_parcours",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
      ],
      headersMembres: [
        {
          text: "ID",
          value: "membres_id_membre",
          label: "ID",
          field: "membres_id_membre",
        },
        {
          text: "Nom",
          value: "nom",
          label: "Nom",
          field: "nom",
        },
        {
          text: "Sexe",
          value: "sexe",
          label: "Sexe",
          field: "sexe",
          dataFormat: this.getSexe,
        },
        {
          text: "Groupe",
          value: "nom_groupe",
          label: "Groupe",
          field: "nom_groupe",
        },
        {
          text: "ID dotation",
          value: "dotations_groupes_id_dotation_groupe",
          label: "ID dotation",
          field: "dotations_groupes_id_dotation_groupe",
        },
        {
          text: "Dotation",
          value: "ll_dotation_groupe",
          label: "Dotation",
          field: "ll_dotation_groupe",
        },
        {
          text: "Totaux",
          value: "nombre",
          label: "Totaux",
          field: "nombre",
        },

        {
          text: "Date",
          value: "date_dotation_groupe",
          label: "Date",
          field: "date_dotation_groupe",
        },

        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          text: "Projet",
          value: "ll_programme",
          label: "Projet",
          field: "ll_programme",
        },
        {
          text: "Activité",
          value: "ll_parcours",
          label: "Activité",
          field: "ll_parcours",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
      ],
      dotationsDeGroupeRegion: [],
      MembresDotationsDeGroupeRegion: [],
      projetSelected: null,
      animateurSelected: null,
      activiteSelected: null,
      activitesFiltered: [],
    };
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    ...mapActions({
      GetArrayRegions: "Utils/GetArrayRegions",
      getAnimateurs: "Users/getAnimateurs",
      getActivites: "Activites/GetAll",
      getProjets: "Projets/getListeProjets",
    }),
    SetProjectList() {
      this.ProjetctList = Array.isArray(this.user.projets)
        ? this.user.projets.map((projet) => projet.id)
        : [];
    },
    gotoPresenceDotationDeGroupe(item) {
      this.$router.push({
        path: `/groupes/presenceDotationGroupe/${item.id}`,
        query: {
          projet: item.ll_programme,
          ll_dotation: item.ll_dotation,
          idAnimateur: item.responsable,
          idGroupe: item.groupes_code_groupe,
        },
      });
    },

    editDotation(item) {
      this.dialogEditDotation = true;
      this.dotationSelected = item;
    },

    closeDialogEditDotation() {
      this.dotationSelected = {
        ll_dotation: "",
        date_dotation: "",
      };
      this.dialogEditDotation = false;
    },
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },

    doEditDotation() {
      var self = this;
      var id = this.dotationSelected.id;
      var lobjet = {
        ll_dotation: self.dotationSelected.ll_dotation,
        date_dotation: self.dotationSelected.date_dotation,
      };

      //Modifier Formation:
      var ref = this.$firebase
        .firestore()
        .collection("dotationsDeGroupe")
        .doc(this.dotationSelected.id);

      ref
        .set(lobjet, { merge: true })
        .then(() => {
          console.log("Dotattion modified ID: ", id);
          // Modifier Présences de la formation

          const PresencesDotations = self.$firebase
            .firestore()
            .collection("presencesDotationsGroupes");

          PresencesDotations.where(
            "dotations_groupes_id_dotation_groupe",
            "==",
            id
          )
            .get()
            .then((snapshots) => {
              console.log("PresencesDotations successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  PresencesDotations.doc(snap.id).set(
                    {
                      ll_dotation_groupe: self.dotationSelected.ll_dotation,
                      date_dotation_groupe: self.dotationSelected.date_dotation,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap PresencesDotations");
              }
            });
        })
        .catch((error) => {
          console.error("Error Editing document: ", error);
        });

      this.closeDialogEditDotation();
    },

    deleteDotationAndPresence(item) {
      let self = this;
      var id = item.id;
      var idGroupe = item.groupes_code_groupe;
      const PresencesDotations = self.$firebase
        .firestore()
        .collection("PresencesDotationsGroupes");
      this.$confirm(
        "Voulez vous vraiment supprimer la séance de dotation : <strong>" +
          item.ll_dotation +
          "</strong> ?, et sa fiche de distribution ?"
      ).then((res) => {
        if (res) {
          console.log("deleteDotationAndPresence", item);
          var ref = this.$firebase
            .firestore()
            .collection("dotationsDeGroupe")
            .doc(item.id);

          ref
            .delete()
            .then(() => {
              PresencesDotations.where(
                "dotations_groupes_id_dotation_groupe",
                "==",
                id
              )
                .get()
                .then((snapshots) => {
                  console.log("PresencesDotations successfully deleted!");
                  if (snapshots.size > 0) {
                    snapshots.forEach((snap) => {
                      PresencesDotations.doc(snap.id).delete();
                    });
                  } else {
                    console.log("no snap PresencesDotationsGroupes");
                  }
                });
              self.getdotationsDeGroupesderegions(self.regionSupervisees);
            })
            .catch((error) => {
              console.error("Error removing document: ", error);
            });
        }
      });
    },

    buildrequest() {
      this.request.projets = this.projetSelected;
      this.request.animateurs = this.animateurSelected;
      this.request.activites = this.activiteSelected;
      console.log("request :", this.request);
    },
    setActivites() {
      console.log("setActivites");
    },
    getDetailsRegionsSupervisees(regionSupervisees) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("regions")
        .where("id", "in", regionSupervisees)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.regions.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          console.log(self.regions);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    getdotationsDeGroupesderegions(arrayRegions) {
      let self = this;
      self.dotationsDeGroupeRegion = [];
      self.$vloading.show();

      var ref = this.$firebase.firestore().collection("dotationsDeGroupe");
      let query = ref
        .where("id_region", "in", arrayRegions)
        .where("date_dotation", ">=", self.start)
        .where("date_dotation", "<=", self.end);

      //Animateur
      console.log("Animateur :", this.request.animateurs);
      if (this.request.animateurs) {
        query = query.where(
          "responsable",
          "==",
          this.request.animateurs.toString()
        );
        console.log("Animateur :", this.request.animateurs);
      }
      //Activites
      if (this.request.activites) {
        console.log("activiteSelected : ", this.activiteSelected);
        query = query.where(
          "parcours_id_parcours",
          "==",
          this.request.activites.toString()
        );
      } else {
        //Projet
        if (this.request.projets) {
          query = query.where(
            "programmes_id_programme",
            "==",
            this.request.projets.toString()
          );
          console.log("Projets :", this.request.projets);
        }
      }

      self.query = query.xd;

      //query final
      const results = query
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.dotationsDeGroupeRegion.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          // self.request = { projets: null, animateurs: null, activites: null };
          /*  self.projetSelected = null;
          self.animateurSelected = null;
          self.activiteSelected = null; */
          self.tab = "dotations";
          self.$vloading.hide();
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },

    getMembresDesDotationsDeGroupesderegions(arrayRegions) {
      let self = this;
      self.MembresDotationsDeGroupeRegion = [];
      self.$vloading.show();
      var ref = this.$firebase
        .firestore()
        .collection("presencesDotationsGroupes");
      let query = ref
        .where("id_region", "in", arrayRegions)
        .where("date_dotation_groupe", ">=", self.start)
        .where("date_dotation_groupe", "<=", self.end);

      //Animateur
      console.log("Animateur :", this.request.animateurs);
      if (this.request.animateurs) {
        query = query.where(
          "id_responsable",
          "==",
          this.request.animateurs.toString()
        );
        console.log("Animateur :", this.request.animateurs);
      }
      //Activites
      if (this.request.activites) {
        console.log("activiteSelected : ", this.activiteSelected);
        query = query.where(
          "parcours_id_parcours",
          "==",
          this.request.activites.toString()
        );
      } else {
        //Projet
        if (this.request.projets) {
          query = query.where(
            "programmes_id_programme",
            "==",
            this.request.projets.toString()
          );
          console.log("Projets :", this.request.projets);
        }
      }

      //query final
      query
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.MembresDotationsDeGroupeRegion.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          self.tab = "membres";
          self.$vloading.hide();
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },

  computed: {
    computedDateDotation() {
      return this.dotationSelected.date_dotation
        ? this.$moment(this.dotationSelected.date_dotation).format("DD-MM-YYYY")
        : "";
    },
    computedStart() {
      return this.start ? this.start : "";
    },
    computedEnd() {
      return this.end ? this.end : "";
    },
    ...mapState({
      user: (state) => state.Auth.user,
      //projets: (state) => state.Projets.projets,
      projets: (state) => state.Auth.user.projets,
      activites: (state) => state.Activites.Activites,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      animateursDeRegions: (state) => state.Users.animateursDeRegions,
      listeRegionsSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isOperateur: (state) => state.Auth.isOperateur,
      animateursDeProjets(state) {
        return state.Users.animateursDeRegions.filter((u) => {
          const projets = Array.isArray(u.projets) ? u.projets : [];
          return projets.some((d) => _.includes(this.ProjetctList, d.id));
        });
      },
    }),
  },
};
</script>

<style lang="scss" scoped></style>
